import React from "react";
import { ShieldCheck, FileText, Bank, ShareNetwork, Coins } from "@phosphor-icons/react";
import { adaFromLovelace } from "@/lib/governance";

const asPct = (v) => (v == null ? "—" : `${(Number(v) * 100).toFixed(0)}%`);

// Option 1 — Key Voting Thresholds with icons + progress bars.
export const ThresholdsCard = ({ params }) => {
  const dr = params?.drep_voting_thresholds || {};
  const sp = params?.pool_voting_thresholds || {};
  const rows = [
    { label: "DRep · No Confidence", v: dr.motion_no_confidence, icon: ShieldCheck, color: "#22d3ee" },
    { label: "DRep · Constitution Update", v: dr.update_to_constitution, icon: FileText, color: "#a855f7" },
    { label: "DRep · Treasury Withdrawal", v: dr.treasury_withdrawal, icon: Bank, color: "#22d3ee" },
    { label: "SPO · Hard Fork", v: sp.hard_fork_initiation, icon: ShareNetwork, color: "#a855f7" },
  ];
  return (
    <div className="h-full flex flex-col justify-between gap-4">
      {rows.map((r) => {
        const Icon = r.icon;
        const frac = r.v == null ? 0 : Math.max(0, Math.min(1, Number(r.v)));
        return (
          <div key={r.label} className="flex items-center gap-3">
            <span className="grid place-items-center h-8 w-8 rounded-lg shrink-0" style={{ background: `${r.color}1a`, border: `1px solid ${r.color}55` }}>
              <Icon size={15} weight="duotone" style={{ color: r.color }} />
            </span>
            <span className="text-[11px] uppercase tracking-[0.1em] mono text-muted-foreground min-w-0 flex-1 truncate">{r.label}</span>
            <div className="relative h-2 rounded-full bg-white/[0.07] w-[90px] sm:w-[150px] flex-none overflow-hidden">
              <div className="absolute inset-y-0 left-0 rounded-full" style={{ width: `${frac * 100}%`, background: `linear-gradient(90deg, ${r.color}99, ${r.color})`, boxShadow: `0 0 8px ${r.color}66` }} />
            </div>
            <span className="text-[13px] mono tabnum text-foreground w-[46px] text-right shrink-0">{asPct(r.v)}</span>
          </div>
        );
      })}
      <div className="h-px bg-primary/10" />
      <div className="flex items-center gap-3">
        <span className="grid place-items-center h-8 w-8 rounded-lg shrink-0" style={{ background: "#22d3ee1a", border: "1px solid #22d3ee55" }}>
          <Coins size={15} weight="duotone" style={{ color: "#22d3ee" }} />
        </span>
        <span className="text-[11px] uppercase tracking-[0.1em] mono text-muted-foreground flex-1">Action Deposit</span>
        <span className="text-[14px] mono tabnum text-[#22d3ee] text-glow-cyan whitespace-nowrap">{adaFromLovelace(params?.governance_actions?.deposit)}</span>
      </div>
    </div>
  );
};
